import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PriceSidebar from './PriceSidebar';
import Stepper from './Stepper';
import { useSnackbar } from 'notistack';
import { saveShippingInfo } from '../../actions/cartAction';
import { useNavigate } from 'react-router-dom';
import MetaData from '../Layouts/MetaData';
import { countries } from '../../utils/location';
import { Autocomplete, Box, Button, Container, Grid, Paper, TextField, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Shipping = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const theme = useTheme();

    const { cartItems } = useSelector((state) => state.cart);
    const { shippingInfo } = useSelector((state) => state.cart);

    const [address, setAddress] = useState(shippingInfo.address || '');
    const [city, setCity] = useState(shippingInfo.city || '');
    const [country, setCountry] = useState(countries.find(c => c.name === shippingInfo.country) || null);
    const [state, setState] = useState(shippingInfo.state || null);
    const [pincode, setPincode] = useState(shippingInfo.pincode || '');
    const [phoneNo, setPhoneNo] = useState(shippingInfo.phoneNo || '');
    const [states, setStates] = useState(shippingInfo.country ? countries.find(c => c.name === shippingInfo.country).states : []);

    const shippingSubmit = (e) => {
        e.preventDefault();

        if (phoneNo.length < 10 || phoneNo.length > 10) {
            enqueueSnackbar("Invalid Phone Number", { variant: "error" });
            return;
        }
        dispatch(saveShippingInfo({ address, city, country: country?.name, state: state, pincode, phoneNo }));
        navigate("/order/confirm");
    }

    const handleCountryChange = (event, newValue) => {
        setCountry(newValue);
        if (newValue) {
            const countryData = countries.find(c => c.name === newValue.name);
            setStates(countryData ? countryData.states : []);
        } else {
            setStates([]);
        }
        setState(null);
    }

    return (
        <>
            <MetaData title="Flipkart: Shipping Details" />
            <Container maxWidth="lg" sx={{ mt: 12, mb: 4 }}>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Paper elevation={3} sx={{ p: 3, bgcolor: 'background.paper' }}>
                            <Stepper activeStep={1}>
                                <Box component="form" onSubmit={shippingSubmit} sx={{ mt: 3, display: 'flex', flexDirection: 'column', gap: 3 }}>
                                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                                        Shipping Details
                                    </Typography>
                                    <TextField
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                        fullWidth
                                        label="Address"
                                        variant="outlined"
                                        required
                                    />

                                    <Box sx={{ display: 'flex', gap: 3 }}>
                                        <TextField
                                            value={pincode}
                                            onChange={(e) => setPincode(e.target.value)}
                                            type="number"
                                            label="Pincode"
                                            fullWidth
                                            variant="outlined"
                                            required
                                        />
                                        <TextField
                                            value={phoneNo}
                                            onChange={(e) => setPhoneNo(e.target.value)}
                                            type="number"
                                            label="Phone No"
                                            fullWidth
                                            variant="outlined"
                                            required
                                        />
                                    </Box>

                                    <Box sx={{ display: 'flex', gap: 3 }}>
                                        <TextField
                                            value={city}
                                            onChange={(e) => setCity(e.target.value)}
                                            label="City"
                                            fullWidth
                                            variant="outlined"
                                            required
                                        />
                                        <TextField
                                            label="Landmark (Optional)"
                                            fullWidth
                                            variant="outlined"
                                        />
                                    </Box>

                                    <Box sx={{ display: 'flex', gap: 3 }}>
                                        <Autocomplete
                                            fullWidth
                                            options={countries}
                                            getOptionLabel={(option) => option.name}
                                            value={country}
                                            onChange={handleCountryChange}
                                            renderInput={(params) => <TextField {...params} label="Country" required />}
                                        />

                                        <Autocomplete
                                            fullWidth
                                            options={states}
                                            getOptionLabel={(option) => option}
                                            value={state}
                                            onChange={(event, newValue) => {
                                                setState(newValue);
                                            }}
                                            renderInput={(params) => <TextField {...params} label="State" required />}
                                        />
                                    </Box>

                                    <Button 
                                        type="submit" 
                                        variant="contained" 
                                        sx={{ 
                                            bgcolor: theme.palette.warning.main, 
                                            '&:hover': { bgcolor: theme.palette.warning.dark },
                                            color: 'white',
                                            py: 1.5,
                                            mt: 2
                                        }}
                                    >
                                        Save and Deliver Here
                                    </Button>
                                </Box>
                            </Stepper>
                        </Paper>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <PriceSidebar cartItems={cartItems} showDeliveryCharge={true} />
                    </Grid>
                </Grid>
            </Container>
        </>
    );
};

export default Shipping;